import eventlogApi from '@/api/eventlog.api'

const state = {
  eventlog: [],
  eventlogTotalCount: 0
}


const getters = {
  eventlog: (state) => {
    return state.eventlog
  },
  eventlogTotalCount: (state) => {
    return state.eventlogTotalCount
  }
}


const actions = {
  async loadEventlog ({ commit, rootState }, { dateFrom, dateTo, skip, take }) {
    const response = await eventlogApi.getEventlog(rootState.tenant.current, dateFrom, dateTo, skip, take)
    commit('SET_EVENTLOG', { eventlog: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async loadEventlogByTennant ({ rootState }, tenant) {
    const response = await eventlogApi.getEventlog(tenant)
    return response.data
  }
}


const mutations = {
  SET_EVENTLOG (state, { eventlog, count }) {
    state.eventlog = eventlog
    state.eventlogTotalCount = count
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
